import React, { useState, useEffect } from 'react';
import { Box, Content, Label, Column } from "rbx";
import { monetaryMask } from '../../commons/masks';

const PurchaseSummary = (props) => {
  const { quantity, discount } = props;
  const costUnit = process.env.REACT_APP_COST_CAD;
  const [costCADs, setCostCADs] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [payable, setPayable] = useState(0);

  useEffect(()=>{
    calculate();
  }, [quantity]);

  const calculate = () => {
    const quantityCADs = quantity||0;
    const discountA = discount||0;

    const costCADsA = quantityCADs * costUnit;
    const discountAmountA = costCADsA * discountA;
    const payableA = costCADsA - discountAmountA;

    setCostCADs( costCADsA );
    setDiscountAmount( discountAmountA );
    setPayable( payableA );
  }

  return (
    <Box>
      <Content>
        <Label>Resumo da Compra:</Label>
        <Column.Group breakpoint="mobile">
          <Column size={8} className="has-text-left">
            1. Valor dos CADs:<br/>
            2. Valor do Desconto:<br/>
            <hr className="m-0 mt-2 mb-2"/>
            <Label>3. Valor a Pagar:</Label>
          </Column>
          <Column className="has-text-right">
            {monetaryMask(costCADs)}<br/ >
            {monetaryMask(discountAmount)}<br/ >
            <hr className="m-0 mt-2 mb-2"/>
            <Label>{monetaryMask(payable)}</Label>
          </Column>
        </Column.Group>
      </Content>
    </Box>
  )

}

export default PurchaseSummary;
